/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Component } from "@angular/core";


@Component({
    selector: 'hc-account-deleted',
    template: `
    <div class="container-fluid">
      <hc-public-header></hc-public-header>
        <div class="row vertical-margin">
            <div class="col-md-5 col-md-offset-3">
                <hc-alert></hc-alert>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 col-md-offset-3">
                <h1 class="h3" data-cy="goodbyeTitle">{{'Danke, dass du Helloclass verwendet hast!' | translate}}</h1>
                <p>{{'Dein Konto wurde deaktiviert und es wird in den nächsten Tagen endgültig gelöscht.' | translate}}</p>
            </div>
        </div>
    </div>
    `
})
export class AccountDeletedPage {

    constructor() {
    }

}
